import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CaseStudyTemplate from './CaseStudyTemplate';

const API = process.env.REACT_APP_BACKEND_URL;

export default function CaseStudyPage() {
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch(`${API}/api/projects/${encodeURIComponent(slug)}`, { cache: 'no-store' });
        if (!res.ok) { setProject(null); return; }
        const data = await res.json();
        setProject(data.project);
      } catch {
        setProject(null);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-gray-200 border-t-gray-800 rounded-full animate-spin" />
      </div>
    );
  }

  return <CaseStudyTemplate project={project} />;
}
